import {Component} from "react";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import axiosTags from "../../../../axios/axios_tag";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Form} from "semantic-ui-react";
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import {Button} from "semantic-ui-react";
import React from "react";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import Lbl from "../../../../components/Label/Lbl";
import GoogleLocation from "../../../../components/GoogleLocation/GoogleLocation";
import './Style.css'
import apiConfig from "../../../../axios/axios_api_services";
import {isOnlyNumbersValdator} from "../../../../util/Validator";
import {withRouter} from "react-router-dom";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/19
 * Time: 3:22 PM
 */

class App extends Component {
  state = {
    name: "",
    address: "",
    location: null,
    subscription: "",
    branchId: 0
  };

  handleChange = name => event => {
    let value = event.target.value;
    this.setState({
      [name]: value
    });
  };

  handleChangeSubscription = e => {
    let value = e.target.value;
    this.setState({
      subscription: value,
    });
  };

  fillData = () => {
    let data = this.props.data;
    this.setState({
      name: data.name,
      address: data.address,
      // location: data.location,
      subscription: data.subscriptionNumber,
      branchId: data.branchId,
    })
  };
  isValidate = (state) => {
    let {modalType} = this.props;

    if (this.state.name.trim() === "" || this.state.address.trim() === "") {
      common.notifyMessage("Please enter all required fields");
    } else {
      const obj = {
        branchId: this.state.branchId,
        name: this.state.name.trim(),
        address: this.state.address.trim(),
        // location: this.state.location.trim(),
        subscriptionNumber: this.state.subscription?this.state.subscription
          : this.state.name.trim().replace(/\s/g, '-') + "_" + new Date().getMilliseconds() + "_" + Math.floor((Math.random() * 10000) + 1)
      };

      swal({
        title: modalType === "UPDATE" ? "Do you want to update branch details?":"Do you want to add branch?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        }
      })
        .then((value) => {
          switch (value) {

            case "action":
              modalType === "UPDATE" ? this.updateBranch(obj) : this.addBranch(obj,state);
              break;
            default:
          }
        });
    }
  };
  updateBranch = (obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.post(apiConfig.CORPORATE_BRANCH_UPDATE, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.closeModal();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateBranch(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  addBranch = (obj,state) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.put(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), obj, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.clearFields();

          if(state === 1){
            common.warningAlert(response.data.message, 0);
            this.props.closeModal();
            this.props.refreshData();
          }else if(state === 2){
            common.warningAlert(response.data.message, 0);
            this.props.refreshData();
          }else if(state === 3){
            let branchId = response.data.branchDTO.branchId;
            this.props.history.push({
              pathname: `/corporate/building/manage`,
              state: `${branchId}`
            })
          }
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.addBranch(obj,state)
        }
      })
  };

  handleChange_ = location => {
    this.setState({location});
  };
  handleSelect_ = location => {
    this.setState({location});
  };
  addressHandler_ = (location) => {
    this.setState({location});
  };
  componentDidMount() {
    if(this.props.modalType === "UPDATE" ) this.fillData();
  }
  clearFields = () => {
    this.setState({
      name: "",
      address: "",
      subscription: "",
    })
  };
  render() {
    return (
      <div>
        <MDBModal isOpen={true} toggle={()=>{}} size="md">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>
            {this.props.modalType === "UPDATE" ? "Update Branch Details" : "Create Branch Details"}
          </MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col lg={12}>
                <Form>
                  <Form.Group widths='equal'>
                    <LabelInput
                      required
                      tagText={"Branch Name"}
                      placeholder={"Branch Name"}
                      value={this.state.name}
                      onChange={this.handleChange('name')}
                    />
                  </Form.Group>

                  <Form.Group widths='equal'>
                    <LabelInput
                      required
                      tagText={"Branch Address"}
                      placeholder={"Branch Address"}
                      value={this.state.address}
                      onChange={this.handleChange('address')}
                    />
                  </Form.Group>

                  {/*<Row>*/}
                    {/*<Col sm={12}>*/}
                      {/*<Lbl marginTop={"0px"} required>Location</Lbl>*/}
                      {/*<GoogleLocation placeholder={"Select location"} location={this.state.location}*/}
                                      {/*handleChange_={this.handleChange_} handleSelect_={this.handleSelect_}*/}
                                      {/*addressHandler_={this.addressHandler_}/>*/}
                    {/*</Col>*/}
                  {/*</Row>*/}

                  {/*<Form.Group widths='equal' style={{marginTop: '15px'}}>*/}
                  {/*  <LabelInput*/}
                  {/*    tagText={"Subscription Number"}*/}
                  {/*    placeholder={"Subscription Number"}*/}
                  {/*    value={this.state.subscription}*/}
                  {/*    onChange={this.handleChangeSubscription}*/}
                  {/*  />*/}
                  {/*</Form.Group>*/}

                </Form>
              </Col>
            </Row>

            <Row>
              {
                this.props.modalType === "UPDATE" ?
                  <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                    <Button className="px-5" onClick={this.isValidate}>Update Branch Details</Button>
                  </Col>
                  :
                  <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                    <Button className="ppx-5 mr-2 mb-2" onClick={()=>this.isValidate(1)}>Save And Close</Button>
                    <Button className="ppx-5 mr-2 mb-2" onClick={()=>this.isValidate(2)}>Save And Create new</Button>
                    <Button className="ppx-5" onClick={()=>this.isValidate(3)}>Save And Add Building</Button>
                  </Col>
              }

            </Row>
          </MDBModalBody>
        </MDBModal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  table_data: state.COPAdminReducer.departmentTable_data,
  departmentData: state.COPAdminReducer.departmentData,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addDepartment: (data) => dispatch(actionCreator.addDepartment(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
